<template>
  <div class="multiselect-container">
    <p>{{ fieldName }}</p>
    <div
      class="select multiselect-item"
      data-type="multi-pills"
      ref="multiselect">
      <button class="btn current-options" type="button">Select option</button>

      <div class="options-list">
        <div class="item" v-for="item in optionItems" :key="item" :class="{active: isSelected(item)}">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select } from '@eds/vanilla';

export default {
  data() {
    return {
      multiselect: Select,
      isInit: false
    };
  },

  props: {
    optionItems: {
      type: Array,
      default: [],
    },

    fieldName: {
      type: String,
      default: 'Field',
    },

    selectedValue: {
        type: Array,
        default() {
            return [];
        }
    }
  },

  mounted() {
    this.initMultiselect();
  },

  watch: {
    'multiselect.selectedOptions.length': function() {
        this.$emit('changeValue', this.multiselect.selectedOptions);
    }
  },

  methods: {
    initMultiselect() {
      const multiselect = this.$refs.multiselect;
      this.multiselect = new Select(multiselect);
      this.multiselect.init();
    },

    isSelected(item) {
        return this.selectedValue.includes(item);
    }
  },
};
</script>

<style lang="less" scoped>
.multiselect-container {
  display: grid;
  padding: 2rem;
}

.multiselect-item {
  max-width: -webkit-fill-available !important;
}
</style>